const decoder = new TextDecoder();

export function blobToBase64(blob: Blob, withPrefix?: boolean): Promise<string | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener('load', (event) => {
      if (!event.target?.result) {
        resolve(null);

        return;
      }

      let fileData =
        typeof event.target.result === 'string' ? event.target.result : decoder.decode(event.target.result);

      if (!withPrefix) {
        fileData = fileData.split('base64,')[1];
      }

      if (!fileData) {
        reject(new Error('File data is not found'));

        return;
      }

      resolve(fileData);
    });

    reader.addEventListener('error', (event) => reject(event.target?.error));

    reader.readAsDataURL(blob);
  });
}
